<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <v-form id="meeting" v-model="valid" ref="form">
    <!-- <Toolbar :title="t('Grupa') + (edit ? ' ' + date : '')"> -->
    <Toolbar :title="t(edit ? (isNew ? 'New meeting' : 'Meeting') : 'Meetings')">
      <div slot="buttons">
        <v-btn icon @click="send" :disabled="readOnly">
          <v-icon>send</v-icon>
        </v-btn>
        <v-menu bottom left v-if="!readOnly">
          <v-btn icon slot="activator" dark>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="save()" :disabled="!dirty">
              <v-list-tile-action> <v-icon>save</v-icon> </v-list-tile-action>
              <v-list-tile-title>{{ t("Save don't send") }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="send" :disabled="!dirty">
              <v-list-tile-action> <v-icon>send</v-icon> </v-list-tile-action>
              <v-list-tile-title>{{ t('Save and send') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="addMeeting" :disabled="isNew">
              <v-list-tile-action>
                <v-icon>add_box</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ t('New meeting') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="remove" :disabled="isNew">
              <v-list-tile-action> <v-icon>delete</v-icon> </v-list-tile-action>
              <v-list-tile-title>{{ t('Delete meeting') }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </Toolbar>

    <CellSelect />
    <!-- Pierwszy ekran z przyciskiem dodania spotkania i listą spotkań -->
    <v-card-title v-show="!edit">
      <!-- <span>Jeśli coś Ci nie wychodzi, zadzwoń na 506 132 662.</span> -->

      <v-btn @click="addMeeting"> Dodaj nowe spotkanie </v-btn>

      <span
        >Lista dotychczasowych spotkań waszej grupy jest poniżej. Kliknij na wybraną datę, aby
        wyświetlić informacje o spotkaniu w danym dniu. </span
      >

      <template v-for="(d, i) in meetingDates">
        <v-btn class="mg-1 px-1" @click="goto(d)">
          {{ d }}
        </v-btn>
        <hr v-if="isCrossingSeason(i)" />
      </template>
      <div v-if="!meetingDates.length" class="accent--text">Lista jest pusta</div>
    </v-card-title>

    <v-card-title primary-title class="pt-2 pb-0 pr-2" id="date-section" v-if="edit">
      <v-btn fab dark small class="accent" @click="create" v-if="!readOnly" :disabled="isNew">
        <v-icon>add</v-icon>
      </v-btn>

      <v-text-field
        v-model="date"
        id="meeting-date"
        type="date"
        :label="t('Meeting date')"
        :hint="dateHint"
        persistent-hint
        required
        class="ml-2 date"
        :rules="validations.date"
        @input="dirty = true"
      ></v-text-field>

      <v-btn @click="prev" :disabled="!prevDate" fab small class="navigate ml-3">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-btn @click="next" :disabled="!nextDate" fab small class="navigate ml-0">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text v-if="edit" class="">
      <CellPersonList />

      <v-expansion-panel class="elevation-0">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Kliknij, aby dodać nową osobę</div>
          </template>
          <v-card>
            <v-form id="person" v-model="valid" ref="newPersonForm">
              <v-layout row wrap>
                <v-text-field
                  ref="personName"
                  label="Pełne imię i nazwisko nowej osoby"
                  :value="person"
                  :error="!!personNameError"
                  :error-messages="personNameError"
                  required
                  @keyup="normalizaPersonName"
                ></v-text-field>
              </v-layout>
              <v-layout row wrap>
                <v-select
                  ref="personRole"
                  :label="t('Role')"
                  v-model="role"
                  v-bind:items="roles(cellType)"
                  item-text="1"
                  item-value="0"
                  style="margin-right: 16px"
                  :error="!!personRoleError"
                  :error-messages="personRoleError"
                  :menu-props="{ maxHeight: '400' }"
                  required
                ></v-select>

                <v-btn color="accent" @click="addPerson">Dodaj osobę</v-btn>
              </v-layout>
            </v-form>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-textarea
        :label="t('Content')"
        :placeholder="currentContentPlaceholder"
        v-model.trim="content"
        auto-grow
        rows="6"
        @focus="currentContentPlaceholder = ''"
        @blur="currentContentPlaceholder = contentPlaceholder"
        @input="dirty = true"
      ></v-textarea>

      <div class="mb-2">
        {{ t('Persons count') }}: <span class="bold">{{ presentCount }}</span
        ><br />
        {{ t('Attendance without guests') }}: {{ presentMemberCount }}/{{ memberCount }}
        =
        <span class="bold">{{ percent }}%</span>
      </div>

      <v-btn color="primary" :disabled="readOnly" @click="send"> Zapisz / wyślij </v-btn>
      <v-btn color="primary" :disabled="saveDisabled" @click="save"> Zapisz </v-btn>

      <v-btn text @click="edit = false">Wróć</v-btn>
    </v-card-text>
  </v-form>
</template>

<script>
import Assignment from '@/components/sub/Assignment'
import CellSelect from '@/components/sub/CellSelect'
import CellPersonList from '@/components/sub/CellPersonList'
import Toolbar from '@/components/layout/Toolbar'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { mapStateMutations } from '@/store'
import { t } from '@/i18n'
import { dayOfWeek, parseDate } from '@/util'

export default {
  components: { Assignment, CellSelect, CellPersonList, Toolbar },
  async created() {
    await this.$store.dispatch('authorize')
    this.contentPlaceholder = this.currentContentPlaceholder
  },

  data() {
    return {
      currentContentPlaceholder: this.t('Content placeholder'),
      person: '',
      role: '',
      personNameError: '',
      personRoleError: '',
    }
  },

  computed: {
    meetingDates() {
      return this.$store.state.meeting2.dates.slice().reverse()
    },
    content: mapStateMutations('meeting2/content'),
    date: mapStateMutations('meeting2/date'),
    dateHint() {
      return dayOfWeek(this.date)
    },
    dirty: mapStateMutations('meeting2/dirty'),
    edit: mapStateMutations('meeting2/edit'),
    saveDisabled() {
      return !this.dirty || !this.presentCount
    },
    valid: mapStateMutations('meeting2/valid'),
    ...mapGetters(['cell', 'cellType', 'roleName', 'roles', 'readOnly']),
    ...mapGetters('meeting2', [
      'prevDate',
      'nextDate',
      'members',
      'presentCount',
      'memberCount',
      'presentMemberCount',
      'percent',
      'attendance',
      'isNew',
      'validations',
    ]),
  },

  methods: {
    ...mapMutations('meeting2', ['togglePresent']),
    ...mapActions('meeting2', ['dates', 'create', 'prev', 'next', 'remove']),
    ...mapActions('assignment', ['changeEnd']),

    isCrossingSeason(i) {
      const dates = this.$store.state.meeting2.dates
      const s1 = dates[dates.length - 1 - i]
      const s2 = dates[dates.length - 2 - i]
      if (!s2) return false
      const d1 = parseDate(s1)
      const d2 = parseDate(s2)
      const y1 = d1.getYear()
      const y2 = d2.getYear()
      const m1 = d1.getMonth()
      const m2 = d2.getMonth()
      const theSameSeason = y1 === y2 && (m1 > 7 && m2 > 7 || m1 < 8 && m2 < 8) || y1 - y2 === 1 && m1 < 8 && m2 > 7
      return !theSameSeason
    },
    addMeeting() {
      this.edit = true
      this.$store.dispatch('meeting2/create')
    },
    addPerson() {
      this.personNameError = this.$refs.personName.value ? '' : t('Required')
      this.personRoleError = this.$refs.personRole.value ? '' : t('Required')
      const valid = this.$refs.personName.value && this.$refs.personRole.value
      if (valid) {
        const { person, role } = this
        const cellItem = this.$store.state.cell.oldItem
        const cell = (cellItem && cellItem['.key']) || this.$store.getters['cell/selected']
        this.$store.dispatch('meeting2/addPerson', { cell, person, role })
        this.person = ''
        this.role = ''
        this.$refs.newPersonForm.reset()
      } else {
        this.$store.commit('dialog', {
          title: 'Error',
          content: t('Fix errors'),
          buttons: ['OK'],
        })
      }
    },
    goto(date) {
      // this.$store.dispatch('navigate', { path: '/simple/' + date })
      this.date = date
      this.index = this.$store.state.meeting2.dates.indexOf(date)
      this.$store.dispatch('meeting2/meeting', this.index)
      this.edit = true
    },
    normalizaPersonName(e) {
      const start = e.target.selectionStart
      const name = (e.target.value || '')
        .replace(/(\s{2;})/, ' ')
        .replace(/[\wąćęłóńśżźĄĆĘŁÓŃŚŻŹ]+/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase())
      e.target.value = this.person = name
      e.target.setSelectionRange(start, start)
    },
    save() {
      this.personNameError = ''
      this.personRoleError = ''
      this.$store.dispatch('meeting2/save')
    },
    send() {
      this.personNameError = ''
      this.personRoleError = ''
      this.$store.dispatch('meeting2/send')
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('meeting2/beforeRouteLeave', { to, from, next })
  },
}
</script>

<style lang="stylus">
button, .v-input {
  margin-left: 0 !important;
}

hr {
  width: 100%;
  height: 10px;
  border-width: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2)
}

.v-toolbar__title:not(:first-child) {
  margin-left: 20px;
}

.v-expansion-panel__header {
  padding: 0 !important;
}

#date-section {
  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: rgba(0, 0, 0, 0.12) !important;

    i {
      color: rgba(0, 0, 0, 0.26) !important;
    }
  }
}

#person {
  // border: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0 -16px 0 -16px;
  padding: 8px 16px;
  justify-content: space-between;

  button {
    align-self: flex-end;
    margin-left: auto !important;
    margin-right: 0;
    margin-bottom: 22px;
  }
}
</style>
